<script setup lang="ts">
import { computed } from 'vue'
import { format } from 'date-fns'

const props = defineProps<{
  contentType: string
  ownerName?: string
  lastUpdated?: string
}>()

const formattedLastUpdated = computed(() => {
  if (!props.lastUpdated) return ''
  return format(new Date(props.lastUpdated), 'M/d/yy h:mm a')
})
</script>

<template>
  <div class="bg-green-100 py-4">
    <div class="container">
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-1.5">
          <span class="material-icons-round text-display-sm">visibility</span>
          <span class="text-lg text-gray-900">
            You are viewing {{ contentType }}
            <template v-if="ownerName">
              shared by <span class="font-bold">{{ ownerName }}</span>
            </template>
          </span>
        </div>
        <div v-if="formattedLastUpdated" class="text-sm text-gray-900">
          <span class="font-bold">Last updated:</span> {{ formattedLastUpdated }}
        </div>
      </div>
    </div>
  </div>
</template>
